import React from 'react';
import { PropTypes, number, string } from 'prop-types';
import classnames from 'classnames';

export default function SwapDots(props) {
    const { iterationTab, wrapperClassName, className, activePosition } = props;

    return (
        <div className={wrapperClassName}>
            {iterationTab.map((item, index) => (
                <div
                    className={classnames(className, {
                        'image-product-swipe__point--active':
                            index === activePosition,
                    })}
                    // eslint-disable-next-line react/no-array-index-key
                    key={`item-${index}`}
                />
            ))}
        </div>
    );
}

SwapDots.propTypes = {
    wrapperClassName: string,
    className: string,
    activePosition: number,
    iterationTab: PropTypes.arrayOf(PropTypes.string),
};

SwapDots.defaultProps = {
    wrapperClassName: null,
    className: null,
    activePosition: 0,
    iterationTab: [],
};
